import PropTypes from 'prop-types';
import { historyShape } from 'constants/propTypes';
import AgentPortalError from 'errors/AgentPortalError';
import { ACTION_CODES } from 'constants/errors';
import useCreateProvisionalBooking from 'components/mutations/useCreateProvisionalBooking';
import { gql } from '@apollo/client';

const CreateProvisional = ({
  history: {
    location: { search }
  },
  children,
  ...rest
}) => {
  const isMiceGroupBooking = new URLSearchParams(search).get('miceGroupBooking');

  const update = (cache) => {
    cache.writeQuery({
      query: gql`
        query {
          passengerDetails @client
        }
      `,
      data: {
        passengerDetails: []
      }
    });
  };

  const [createProvisionalBooking, { loading, error }] = useCreateProvisionalBooking({
    update,
    isMiceGroupBooking
  });

  if (error) {
    throw new AgentPortalError(error, ACTION_CODES.BACK_TO_SEARCH_RESULTS);
  }

  return children({ createProvisionalBooking, loading, ...rest });
};

CreateProvisional.propTypes = {
  history: historyShape,
  children: PropTypes.func
};

export default CreateProvisional;
